import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { legalTranslations } from '../translations/legal';

export const Legal = ({ doc }) => {
  const { language } = useLanguage();
  const t = legalTranslations[language][doc];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [doc, language]);

  return (
    <div className="min-h-screen pt-20 bg-gradient-to-br from-teal-50 via-white to-pink-50">
      <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-10" data-testid={`legal-${doc}`}>
            <h1 className="text-3xl sm:text-4xl font-light text-teal-600 mb-2">{t.title}</h1>
            <p className="text-sm text-gray-400 mb-8">{t.updated}</p>

            {t.intro && (
              <p className="text-gray-700 leading-relaxed mb-8">{t.intro}</p>
            )}

            <div className="space-y-8">
              {t.sections.map((section, i) => (
                <div key={i}>
                  <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-3">{section.heading}</h2>
                  {section.paragraphs && section.paragraphs.map((p, j) => (
                    <p key={j} className="text-gray-700 leading-relaxed mb-2">{p}</p>
                  ))}
                  {section.items && (
                    <ul className="list-disc pl-5 space-y-1.5 text-gray-700 leading-relaxed mt-2">
                      {section.items.map((item, k) => (
                        <li key={k}>{item}</li>
                      ))}
                    </ul>
                  )}
                  {section.after && (
                    <p className="text-gray-700 leading-relaxed mt-3">{section.after}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
